import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

const fallbackLng = 'ar'
const availableLanguages = ['en', 'ar']
const userLanguageSelectedKey = 'oraxUserLanguageSelected'

if (typeof window !== 'undefined' && window.localStorage.getItem(userLanguageSelectedKey) !== 'true') {
    window.localStorage.setItem('i18nextLng', fallbackLng)
}

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng,
        detection: {
            order: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage'],
            checkWhitelist: true
        },
        debug: false,
        load: 'languageOnly',
        supportedLngs: availableLanguages,
        whitelist: availableLanguages,
        interpolation: {
            escapeValue: false // no need for react. it escapes by default
        }
    })

export default i18n